module.exports = {
  init: function () {

    const collapseToggles = $('[data-collapse]');

    collapseToggles.click(function (e) {

      e.preventDefault();

      const item = $(e.currentTarget);
      const target = $(item.data('collapse-target'));

      if (target[0].style.display !== 'none') {
        console.log('hide');
        target.hide();
      } else {
        console.log('show');
        target.show();
      }

      item.toggleClass('is-active');

    });

  }
}
